import { useQuery } from '@tanstack/react-query';
import { getGlobalFeatureFlags } from '@api/globalFeatures';
import { trackQueryError } from '@src/utils/sensor/apptracker';
import useGlobalFeatureFlagsStore from '@globalStore/globalFeatureFlagsStore';
import { isEmpty } from 'lodash';

const useGlobalFeatureFlags = ({ enabled = true }) => {
  const { setGlobalFeatures } = useGlobalFeatureFlagsStore.getState();

  // refetch and update FF every 5m
  const { isError, isFetched } = useQuery(
    ['global-feature-flags'],
    async () => {
      const { data: resp } = await getGlobalFeatureFlags({});
      // Transform the API response into a more usable format
      const transformedData = resp?.data.reduce((acc, flag) => {
        acc[flag.flagName] = flag.isEnabled;
        return acc;
      }, {});

      if (!isEmpty(transformedData)) {
        setGlobalFeatures(transformedData);
        return transformedData;
      }
      return null;
    },
    {
      refetchOnWindowFocus: false,
      retry: false,
      enabled,
      staleTime: Infinity,
      keepPreviousData: true,
      refetchInterval: 5 * 60 * 1000,
      notifyOnChangeProps: ['isError', 'isFetched'],
      onError: (err) => {
        trackQueryError({ type: 'global-feature-flags', err });
      },
    },
  );
  return { isError, isFetched };
};

export default useGlobalFeatureFlags;
